import React, { useState, useCallback } from 'react';
import { PaymentSource } from '../../constants';
import { reportError } from '../../lib/reportError';
import { useErrorModal } from '../../hooks/useErrorModal';
import { useCheckout } from '../../hooks/useCheckout';
import {
  useUpdateCartMutation,
  CartUpdateAction,
  CartUpdatePropertyName
} from '../../hooks/useCart';
import { CheckoutSection } from '../CheckoutSection';
import { AmazonShippingAndPaymentPreview } from './AmazonShippingAndPaymentPreview';
import { AmazonShippingAndPaymentForm } from './AmazonShippingAndPaymentForm';

enum Mode {
  Resting,
  Editing
}

export const AmazonShippingAndPayment = () => {
  const { showErrorModal } = useErrorModal();
  const { isShippingAddressSelected, isPaymentMethodSelected } = useCheckout();
  const [updateCart] = useUpdateCartMutation();
  const [mode, setMode] = useState(
    isShippingAddressSelected && isPaymentMethodSelected ? Mode.Resting : Mode.Editing
  );

  const handleCancel = useCallback(async () => {
    if (isShippingAddressSelected && isPaymentMethodSelected) {
      setMode(Mode.Resting);
    } else {
      try {
        await updateCart(CartUpdateAction.PaymentSource, {
          [CartUpdatePropertyName.PaymentSource]: PaymentSource.Adyen
        });
      } catch (error) {
        reportError(error);
        showErrorModal();
      }
    }
  }, [isPaymentMethodSelected, isShippingAddressSelected, showErrorModal, updateCart]);

  return (
    <CheckoutSection title="Shipping &amp; Payment">
      {mode === Mode.Resting && (
        <AmazonShippingAndPaymentPreview onEdit={() => setMode(Mode.Editing)} />
      )}
      {mode === Mode.Editing && (
        <AmazonShippingAndPaymentForm
          onClose={() => setMode(Mode.Resting)}
          onCancel={handleCancel}
        />
      )}
    </CheckoutSection>
  );
};
